
window.FASTR_FRONTEND = window.FASTR_FRONTEND || {};
window.FASTR_FRONTEND.searchSpringQueue = [];

document.addEventListener('DOMContentLoaded', async function() {
    const collectionContainer = document.querySelector('.collection-container');
    const productGridContainer = document.querySelector('.collection-container #ProductGridContainer');
    const urlParams = new URLSearchParams(window.location.search);
    const pageNumber = urlParams.get('page') ? parseInt(urlParams.get('page')) : 1;
    const shopUrl = Shopify.shop;
    let abortController;
    const prodGrid = productGridContainer.querySelector('#product-grid');
    const color_settings = window[`settings`];
    const customColorsArray = color_settings.color_swatches.split(',').map(color => {
        const [key, value] = color.split(':').map(part => part.trim());
        return { key: key.toLowerCase(), value: value };
    });
    const keyArray = customColorsArray.map((color) => color.key);
    const valArray = customColorsArray.map((color) => color.value);
    if(prodGrid){
        const baseUrl = 'https://cr8s7s.a.searchspring.io/api/search/search.json';
        const queryParams = {
            ajaxCatalog: 'v3',
            resultsFormat: 'native',
            siteId: 'cr8s7s',
            domain: window.location.origin + window.location.pathname,
            bgfilter: {
                collection_handle: collectionHandle,
                ss_available: '1'
            },
            filter: {},
            type: 'filter',
            q: '',
            page: pageNumber,
            userId: 'db8c2ca1-e581-4f07-9c2f-f8ce16fd9b66',
            sessionId: '164b6ef2-b723-43bb-ab2e-d0ba28622e46',
            pageLoadId: '79ac628a-ef44-4959-9d1c-e70702a24739'
        };
    
        function debounce(func, delay) {
            let timeoutId;
            return function (...args) {
                if (timeoutId) clearTimeout(timeoutId);
                timeoutId = setTimeout(() => func.apply(this, args), delay);
            };
        }
    
        async function FacetsToggle() {
            const container = document.getElementById("Facet-Drawer");
            const button = document.getElementById("Facets-Toggle");
          
            if (button) {
              button.addEventListener("click", function(e) {
                e.preventDefault();
                document.getElementsByTagName("body")[0].classList.toggle("open-cc");
                container.classList.toggle("active");
              });
            }
        }
    
        const checkAndValidateFilters = async(collectionHandle) => {
            let storedFilters = JSON.parse(sessionStorage.getItem('natoriFilters') || '{}');
            if (storedFilters.hasOwnProperty('search_query')) {
                delete storedFilters.search_query;
                storedFilters.collection_handle = collectionHandle;
                sessionStorage.setItem('natoriFilters', JSON.stringify(storedFilters));
                sessionStorage.removeItem('natoriSortData');
            }
            if (storedFilters.hasOwnProperty('collection_handle')) {
                if (storedFilters.collection_handle !== collectionHandle) {
                    sessionStorage.removeItem('natoriFilters');
                    sessionStorage.removeItem('natoriSortData');
                }
            }
        };
        
    
        const fetchColorValue = async (key) => {
            let colorValue = key.toLowerCase().trim();
            const customColorIndex = keyArray.indexOf(colorValue);
            if (customColorIndex > -1) {
                colorValue = valArray[customColorIndex];
            }
        
            let bgValue = false;
            if (colorValue.includes(".")) {
                bgValue = colorValue;
                colorValue = "var(--bg-body)";
            }
        
            const shopDomain = window.location.hostname;
            const bgImageUrl = bgValue? `--option-color-image: url('//${shopDomain}/cdn/shop/files/${bgValue}');`: "--option-color-image: false";
            const style = `--bg-color: ${colorValue}; ${bgImageUrl}`;
            return style;
        };
    
        const updateColorValue = async () => {
            const colorLabels = document.querySelectorAll('.thb-filter ul.list-color label.facet-checkbox');
            for (const label of colorLabels) {
                try {
                    const colorKey = label.dataset.key;
                    const colorValue = await fetchColorValue(colorKey);
        
                    if (colorValue) {
                        const styles = colorValue.split(';').filter(Boolean);
        
                        styles.forEach(style => {
                            const [property, value] = style.split(':').map(s => s.trim());
                            if (property && value) {
                                label.style.setProperty(property, value);
                            }
                        });
                    } else {
                        console.warn(`No color value returned for key: ${colorKey}`);
                    }
                } catch (error) {
                    console.error(`Failed to fetch or apply color value for key: ${label.dataset.key}`, error);
                }
            }
        };  
    
        // const formatPrice = (price) => {
        //     const number = parseFloat(price);
        //     return number % 1 === 0 ? number.toFixed(0) : number.toFixed(2);
        // };
    
        const formatPrice = (price) => {
            const number = parseFloat(price);
            const currency = window.theme.settings.money_with_currency_format.replace(/{{.*?}}/g, '');
            
            let locale;
             switch (currency) {
                case '€': 
                    locale = 'de-DE';
                    break;
                case 'CHF':
                    locale = 'de-CH';
                    break;
                case 'R$':
                    locale = 'pt-BR';
                    break;
                case '¥':
                    locale = 'ja-JP';
                    break;
                case '$':
                default:
                    locale = 'en-US';
                    break;
            }
        
            return number.toLocaleString(locale, { 
                minimumFractionDigits: 0, 
                maximumFractionDigits: 2 
            });
        };
    
    
    
        const getStep = (minPrice, maxPrice) => {
            const divisors = [10, 7, 5, 3, 2, 1];
            let step = 1;
        
            for (const divisor of divisors) {
                if (minPrice % divisor === 0 && maxPrice % divisor === 0) {
                    return divisor;
                }
            }
        
            for (const divisor of divisors) {
                if (maxPrice % divisor === 0) {
                    return divisor;
                }
            }
        
            return step;
        };
    
        await checkAndValidateFilters(collectionHandle);
    
        const buildQueryString = (params) => {
            const parts = [];
        
            const processKey = (key, value) => {
                if (Array.isArray(value)) {
                    return value.map(item => `${encodeURIComponent(key)}=${encodeURIComponent(item)}`).join('&');
                } else if (typeof value === 'object' && value !== null) {
                    return Object.keys(value)
                        .map(subKey => processKey(`${key}.${subKey}`, value[subKey]))
                        .join('&');
                } else {
                    return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
                }
            };
        
            Object.keys(params).forEach(key => {
                if (typeof params[key] === 'object' && params[key] !== null) {
                    parts.push(processKey(key, params[key]));
                } else {
                    parts.push(processKey(key, params[key]));
                }
            });
        
            return parts.join('&');
        };
    
        async function createProductGrid(products, inlineContent, paginationData) {
            const productGrid = document.getElementById('product-grid');
            productGrid.innerHTML = ''; // Clear existing products
    
            const productsPerPage = paginationData.perPage;
            const currentPage = paginationData.currentPage;
            let totalResults;
            if (inlineContent && inlineContent.length > 0) {
                totalResults = Math.max(0, parseInt(paginationData.totalResults) - 1);
            } else {
                totalResults = Math.max(0, parseInt(paginationData.totalResults));
            }

            const totalProds = totalResults > 1 ? `${totalResults} products` : `${totalResults} product`;
            
            const countLabels = document.querySelectorAll('.facets-mobile-container .thb-filter-count span.facets__label, facetfiltersformmobile .side-panel-inner .thb-filter-count span.facets__label');
            if (countLabels) {
              countLabels.forEach(label => {
                label.textContent = totalProds;
              });
            }
    
            let inlineIndex = -1;
            let inlineInserted = false;
            let customLabel = false;
            let customSwatch;
            const defaultImageUrl = `https://${shopUrl}/cdn/shop/t/1/assets/natoriplaceholder.png`;
    
            if (inlineContent && inlineContent.length > 0) {
                inlineIndex = inlineContent[0].config.position.index;
            }
    
            products.forEach((product, index) => {
                const prodVariant = parseVariant(product.variants);
                const firstVariant = prodVariant[0];
                let priceContainer = `<ins><span class="amount">$${formatPrice(product.price)}</span></ins>`;
                let comparePriceContainer = '';
                if(firstVariant){
                    const comparePrice = parseFloat(firstVariant.compare_at_price);
                    const sellPrice = parseFloat(firstVariant.price);
                    if(comparePrice>sellPrice){
                        priceContainer =`<ins><span class="amount">$${formatPrice(sellPrice)}</span></ins>`;
                        comparePriceContainer =`<del><span class="amount">$${formatPrice(comparePrice)}</span></del>`;
                    }
                }
                let prodImage = product.thumbnailImageUrl ? product.thumbnailImageUrl: defaultImageUrl;
                const collPrimaryImage = collectionImage(product);
                const collectionProdImage = collPrimaryImage?`<img class="product-primary-image coll-image lazyautosizes" src="${collPrimaryImage}" alt="${product.name}" style="width:100%;height:100%;"/>`: `<img class="product-primary-image lazyautosizes" src="${prodImage}" alt="${product.name}" style="width:100%;height:100%;"/>`;
                let variantPrimaryImage = '';
                if(collPrimaryImage){
                    variantPrimaryImage = `<span class="product-coll-images" data-primary="${collPrimaryImage}" data-secondary="${prodImage}" style="display:none;" />`;    
                }
                const productElement = document.createElement('li');
                productElement.className = 'column';
                const productHTML = `
                    <product-card class="product-card text-center hide-price">
                        <figure class="product-featured-image spin_overlay">
                            <a href="${product.url}" title="${product.name}" class="product-featured-image-link aspect-ratio aspect-ratio--adapt" style="--padding-bottom: 150%;">
                                ${collectionProdImage}
                                ${variantPrimaryImage}
                            </a>
                        </figure>
                        <div class="product-card-info">
                            <div class="productInfosection">
                                <div class="productInfoleft">
                                    <div class="product-card-vendor"><a href="/collections/vendors?q=${product.vendor}" title="${product.vendor}">${product.vendor}</a></div>
                                    <a href="${product.url}" title="${product.name}" class="product-card-title">${product.name}</a>
                                </div>
                                <div class="productInfoRight">
                                    <div class="plpRatings">
                                      <div class="yotpo-widget-instance yotpo bottomLine" data-product-id="${product.uid}"></div>
                                    </div>
                                    <span class="price">${comparePriceContainer}${priceContainer}</span>
                                </div>
                            </div>
                            <div class="product-card-swatch" data-product-id="${product.uid}">
                                <div class="product-card-swatches no-js-hidden" id="swatch_section_${product.uid}"></div>
                            </div>
                        </div>
                    </product-card>
                `;
    
                productElement.innerHTML = productHTML;
                if(product.mfield_custom_product_custom_swatch){
                    customSwatch = parseVariant(product.mfield_custom_product_custom_swatch);
                }
                if(Array.isArray(customSwatch) && customSwatch.length > 0){
                    if (prodVariant && prodVariant.length > 0) {
                      const customProdSwatchData = {
                          featured_image_id: prodVariant[0].id,
                          custom_handle: product.url,
                          product_gids: customSwatch
                      };
                  
                      const customProdSwatch = `window.settings_${product.uid} = ${JSON.stringify(customProdSwatchData)}`;
                  
                      const customProdSwatchScript = document.createElement('script');
                      customProdSwatchScript.textContent = customProdSwatch;
                  
                      const productSwatch = productElement.querySelector('.product-card .product-card-swatch');
                      const productSwatchDirectory = productElement.querySelector('.product-card .product-card-info');
                  
                      if (productSwatch && productSwatchDirectory) {
                          productSwatch.insertAdjacentElement('afterend', customProdSwatchScript);
                      } else {
                          console.error('productSwatch or productSwatchDirectory not found');
                      }
                    } else {
                        console.error('No variants found for product');
                    }
                }else {
                    const productSwatch = productElement.querySelector('.product-card .product-card-swatch');
                    if (productSwatch) {
                        productSwatch.remove();
                    } else {
                        console.error('productSwatch not found');
                    }
                }
                const saleLabel = saleBadge(prodVariant);
              
                if(saleLabel != null && saleLabel != 'Sale'){
                  customLabel = true;
                  const featureImage = productElement.querySelector('figure.product-featured-image');
                  const featureTag = featureImage.querySelector('a.product-featured-image-link.aspect-ratio');
    
                   const saleLabelElement = document.createElement('span');
                   saleLabelElement.classList = "badge top left";
                   if (saleLabel == 'Sale'){
                      saleLabelElement.classList.add("onsale");  
                   }else{
                      saleLabelElement.classList.add("out-of-stock"); 
                   }
                   saleLabelElement.innerHTML = saleLabel;
                  featureImage.insertBefore(saleLabelElement, featureTag);
                }
    
                if(product.mfield_custom_product_label){
                  const customMetaLabel = String(product.mfield_custom_product_label);
                  const featureImage = productElement.querySelector('figure.product-featured-image');
                  const featureTag = featureImage.querySelector('a.product-featured-image-link.aspect-ratio');
    
                   const customLabelElement = document.createElement('span');
                   if (customLabel){
                      customLabelElement.classList = "badge top right";
                   }else{
                      customLabelElement.classList = "badge top left";
                   }
                   customLabelElement.innerHTML = customMetaLabel;
                    featureImage.insertBefore(customLabelElement, featureTag);
                }
    
                if (!inlineInserted && inlineIndex >= 0 && inlineIndex < productsPerPage * currentPage) {
                    const inlinePage = Math.ceil(inlineIndex / productsPerPage);
                    const positionOnPage = inlineIndex % productsPerPage;
    
                    if (currentPage === inlinePage && index === positionOnPage) {
                        const inlineElement = createInlineContentElement(inlineContent[0]);
                        if(inlineElement){
                          productGrid.appendChild(inlineElement);
                          inlineInserted = true;
                        }
                    }
                }
                productGrid.appendChild(productElement);
            });
    
            if (!inlineInserted && inlineIndex >= productsPerPage * currentPage - productsPerPage && inlineIndex < productsPerPage * currentPage) {
                const inlineElement = createInlineContentElement(inlineContent[0]);
              if(inlineElement){
                productGrid.appendChild(inlineElement);
              }
            }
            createPagination(paginationData);
        }
    
        const parseVariant = (rowVariant) => {
            const stringifiedArray = rowVariant;
            const correctedString = stringifiedArray.replace(/&quot;/g, '"');
            const jsonObjectArray = JSON.parse(correctedString);
            return jsonObjectArray;
        };
    
        const collectionImage = (product) => {
            let primaryImage = null;
            const metafieldArray = ['mfield_custom_category_image_map', 'mfield_custom_category_image_map_2nd', 'mfield_custom_category_image_map_3rd', 'mfield_custom_category_image_map_4th', 'mfield_custom_category_image_map_5th', 'mfield_custom_category_image_map_6th', 'mfield_custom_category_image_map_7th'];
            for (const metafieldKey of metafieldArray) {
                const metafieldValue = product[metafieldKey];
                if (Array.isArray(metafieldValue) && metafieldValue.length === 2) {
                    const [id, imageUrl] = metafieldValue;
                    
                    if (collectionId == id) {
                        primaryImage = imageUrl;
                        return primaryImage;
                    }
                }
            }
            return primaryImage;
        };
    
        const collectionSwatchImages = async () => {
            const productCards = document.querySelectorAll('#product-grid product-card.product-card');
            productCards.forEach((productCard) => {
                const collImage = productCard.querySelector('.product-featured-image span.product-coll-images');
                if(collImage){
                    const primaryImage = collImage.getAttribute('data-primary');
                    const secondaryImage = collImage.getAttribute('data-secondary');
                    const prodActiveSwatch = productCard.querySelector('.product-card-info .product-card-swatch .product-card-swatches .product-card-swatch.active');
                    if(prodActiveSwatch){
                        prodActiveSwatch.setAttribute('data-srcset', primaryImage);
                        prodActiveSwatch.setAttribute('data-srcset-2', secondaryImage);
                        const prodSecondary = productCard.querySelector('.product-secondary-image');
                        if(prodSecondary){
                            prodSecondary.setAttribute('data-srcset', secondaryImage);
                        }
                    }
                }
            });
        };
    
        const saleBadge = (prodVariant) => {
            if (!Array.isArray(prodVariant) || prodVariant.length === 0) {
                return null;
            }
            const totalInventory = prodVariant.reduce((total, variant) => {
                return total + (variant.inventory_quantity || 0);
            }, 0);
    
            if (totalInventory < 1) {
                return `Out of Stock`;
            }
        
            const firstVariant = prodVariant[0];
            const firstVariantComparePrice = parseFloat(firstVariant.compare_at_price) || null;
            const firstVariantPrice = parseFloat(firstVariant.price) || null;
        
            if (firstVariantComparePrice && firstVariantPrice && firstVariantComparePrice > firstVariantPrice) {
                return `Sale`;
            }
        
            return null;
        };

    
        function createInlineContentElement(inlineContent) {
            try {
                const inlineElement = document.createElement('li');
                inlineElement.className = 'column';
                const inlineUrl = inlineContent.value.match(/data-target-url="([^"]+)"/)?.[1] ?? 'javascript:void';
                const inlineBanner = inlineContent.value.match(/data-image-url="([^"]+)"/)?.[1] ?? `https://${shopUrl}/cdn/shop/t/1/assets/natoriplaceholder.png`;
                const inlineAlt = inlineContent.value.match(/data-target-title="([^"]+)"/)?.[1] ?? 'Natori';
        
                const inlineHTML = `
                    <product-card class="product-card text-center">
                        <figure class="product-featured-image spin_overlay">
                            <a href="${inlineUrl}" title="${inlineAlt}" class="product-featured-image-link aspect-ratio aspect-ratio--adapt" style="--padding-bottom: 150%;">
                                <img class="product-primary-image lazyautosizes" src="${inlineBanner}" alt="${inlineAlt}" style="width: 100%;" />
                            </a>
                        </figure>
                    </product-card>
                `;
                inlineElement.innerHTML = inlineHTML;
                return inlineElement;
            } catch (error) {
                console.error('Error creating inline content element:', error);
                return null;
            }
         }

    
        const updateFacetValues = async (facets) => {
            facets.forEach((facet) => {
                if (facet.type === 'list' && facet.label != 'Price') {
                    const facetName = facet.field.replace("variant_", "");
                    if (facetName !== 'collection_handle' && facetName !== 'ss_available' && facetName !== 'tags' && facetName !== 'ss_has_tags') {
                        const facetContainers = document.querySelectorAll(`.thb-filter:has(ul.list-${facetName})`);
                        facetContainers.forEach((facetContainer) => {
                            facet.values.forEach((value) => {
                                if (value.active == true) {
                                    const activeInput = facetContainer.querySelector(`ul.list-${facetName} input[value="${value.label}"]`);
                                    if (activeInput) {
                                        activeInput.checked = true;
                                    }
                                }
                            });
                            let selectedFacets = 0;
                            const facetUl = facetContainer.querySelector(`ul.list-${facetName}`);
                            const checkedfacet = facetUl.querySelectorAll('input[type="checkbox"]');
                            checkedfacet.forEach((checkbox) => {
                                if (checkbox.checked) {
                                    selectedFacets++;
                                }
                            });
                            const facetCounter = facetContainer.querySelector(".thb-filter-dropdown__footer span.facets__selected");
                            if (facetCounter) {
                                facetCounter.textContent = `${selectedFacets} selected`;
                            }
                        });
                    }
                }
            });
        };

    
        function createPagination(paginationData) {
            const { currentPage, totalPages, nextPage, previousPage } = paginationData;
            const paginationContainer = document.querySelector('.pagination');
            paginationContainer.innerHTML = '';
        
            const paginationHtml = document.createElement('div');
            paginationHtml.className = 'page-numbers nav-links';
        
            if (previousPage > 0) {
                const prevButton = document.createElement('span');
                prevButton.className = 'prev';
                prevButton.innerHTML = `<a href="${previousPage === 1 ? window.location.pathname : '?page=' + previousPage}" title="Previous">←</a>`;
                paginationHtml.appendChild(prevButton);
            }
        
            let startPage, endPage;
            if (totalPages <= 10) {
                startPage = 1;
                endPage = totalPages;
            } else {
                if (currentPage <= 4) {
                    startPage = 1;
                    endPage = 5;
                } else if (currentPage > totalPages - 4) {
                    startPage = totalPages - 4;
                    endPage = totalPages;
                } else {
                    startPage = currentPage - 2;
                    endPage = currentPage + 2;
                }
            }
        
            if (startPage > 1) {
                paginationHtml.innerHTML += `<span class="page"><a href="${window.location.pathname}" title="Page 1">1</a></span>`;
                if (startPage > 2) {
                    paginationHtml.innerHTML += `<span class="deco">...</span>`;
                }
            }
        
            for (let i = startPage; i <= endPage; i++) {
                const pageSpan = document.createElement('span');
                pageSpan.className = 'page';
                if (i === currentPage) {
                    pageSpan.classList.add('current');
                    pageSpan.textContent = i;
                } else {
                    pageSpan.innerHTML = `<a href="${i === 1 ? window.location.pathname : '?page=' + i}" title="Page ${i}">${i}</a>`;
                }
                paginationHtml.appendChild(pageSpan);
            }
        
            if (endPage < totalPages) {
                if (endPage < totalPages - 1) {
                    paginationHtml.innerHTML += `<span class="deco">...</span>`;
                }
                paginationHtml.innerHTML += `<span class="page"><a href="?page=${totalPages}" title="Page ${totalPages}">${totalPages}</a></span>`;
            }
        
            if (nextPage <= totalPages && nextPage > 0) {
                const nextButton = document.createElement('span');
                nextButton.className = 'next';
                nextButton.innerHTML = `<a href="?page=${nextPage}" title="Next">→</a>`;
                paginationHtml.appendChild(nextButton);
            }
        
            paginationContainer.appendChild(paginationHtml);
        }
    
    
        async function createMobFilters(facets) {
            pageLoad = false;
            const filterMobContainer = document.getElementById('FacetFiltersFormMobile');
            filterMobContainer.querySelectorAll('.thb-filter').forEach(el => el.remove());
        
            if (!facets || facets.length === 0) {
                return;
            }
        
            const flattenedArray = await flattenCategories(categoryCollection);
            const createMobFacetElement = (facet, index, facetOptionsHTML) => {
                const facetMobElement = document.createElement('div');
                facetMobElement.className = 'thb-filter js-filter';
                facetMobElement.setAttribute('data-index', index + 1);
        
                const facetMobTitle = document.createElement('div');
                facetMobTitle.className = 'thb-filter-title';
                facetMobTitle.textContent = facet.label.replace("variant_", "");
        
                const facetDropdown = document.createElement('div');
                facetDropdown.className = 'thb-filter-dropdown';
        
                const facetInner = document.createElement('div');
                facetInner.className = 'thb-filter-dropdown__inner';
                facetInner.innerHTML = facetOptionsHTML;
                facetDropdown.appendChild(facetInner);
        
                facetMobElement.appendChild(facetMobTitle);
                facetMobElement.appendChild(facetDropdown);
                filterMobContainer.appendChild(facetMobElement);
            };
        
            facets.forEach((facet, index) => {
                if (facet.label === 'collection_handle' || facet.label === 'ss_available' || facet.label === 'tags' || facet.label === 'ss_has_tags') {
                    return;
                }
        
                let facetOptionsHTML = '';
        
                if (facet.label === 'Category' && facet.type === 'list') {
                    const matchingValues = facet.values.filter(value => flattenedArray.includes(value.label));
                    if (matchingValues.length > 0) {
                        facetOptionsHTML = createOptionsHTML(matchingValues, facet.field);
                        createMobFacetElement(facet, index, facetOptionsHTML);
                    }
                } else if (facet.type === 'range' || facet.type === 'slider') {
                    const minPrice = facet.range[0];
                    const maxPrice = facet.range[1];
                    const step = getStep(minPrice, maxPrice);
                    facetOptionsHTML = `
                        <div class="price_range price_range-${facet.field}">
                            <span class="price-highest">The highest price is $${maxPrice}</span>
                            <price-slider class="price_slider_wrapper">
                                <div class="slider">
                                    <div class="progress"></div>
                                </div>
                                <div class="natori-range-input">
                                    <input type="range" class="range-min" min="${minPrice}" max="${maxPrice}" value="${minPrice}" step="${step}">
                                    <input type="range" class="range-max" min="${minPrice}" max="${maxPrice}" value="${maxPrice}" step="${step}">
                                </div>
                                <div class="price_slider_amount natori-price-input">
                                      <div class="field">
                                          <span class="field-currency">$</span>
                                          <input type="number" class="input-min" value="${minPrice}">
                                      </div>
                                      <div class="field">
                                          <span class="field-currency">$</span>
                                          <input type="number" class="input-max" value="${maxPrice}">
                                      </div>
                                </div>
                            </price-slider>
                        </div>
                    `;
                    createMobFacetElement(facet, index, facetOptionsHTML);
                } else if (facet.type === 'list' && facet.label !== 'Price') {
                    facetOptionsHTML = createOptionsHTML(facet.values, facet.field);
                    createMobFacetElement(facet, index, facetOptionsHTML);
                }
            });
        
            await attachFilterListeners();
        }
    
        
        async function createFilters(facets) {
            pageLoad = false;
            const filterContainer = document.querySelector('.facets__wrapper');
            filterContainer.querySelectorAll('.thb-filter').forEach(el => el.remove());
            const flattenedArray = await flattenCategories(categoryCollection);
        
            if (!facets || facets.length === 0) {
                return;
            }
        
            const createFacetElement = (facet, index, facetOptionsHTML) => {
                const facetElement = document.createElement('details');
                facetElement.className = 'thb-filter';
                facetElement.setAttribute('data-index', index + 1);
                facetElement.setAttribute('data-type', facet.field.replace("variant_", ""));
        
                const facetSummary = document.createElement('summary');
                facetSummary.className = 'thb-filter-title';
                if (facet.type === 'range' || facet.type === 'slider') {
                  facetSummary.textContent = facet.label.replace("variant_", "");
                  facetSummary.style.textTransform = 'capitalize';
                }else{
                  facetSummary.textContent = facet.label;
                }
        
                const facetDropdown = document.createElement('div');
                facetDropdown.className = 'thb-filter-dropdown';
                const facetInner = document.createElement('div');
                facetInner.className = 'thb-filter-dropdown__inner';
                facetInner.innerHTML = facetOptionsHTML;
                facetDropdown.appendChild(facetInner);
        
                if (facet.type !== 'range' && facet.type !== 'slider') {
                    const facetFooter = document.createElement('div');
                    facetFooter.className = 'thb-filter-dropdown__footer';
                    facetFooter.innerHTML = `
                        <span class="facets__selected no-js-hidden">0 selected</span>
                        <!--<a href="/collections/${collectionHandle}" class="facets__reset">Reset</a>-->
                        <a href="#" class="facets__reset">Reset</a>
                    `;
                    facetDropdown.appendChild(facetFooter);
                }
        
                facetElement.appendChild(facetSummary);
                facetElement.appendChild(facetDropdown);
                filterContainer.appendChild(facetElement);
            };
        
            facets.forEach((facet, index) => {
                if (facet.label === 'collection_handle' || facet.label === 'ss_available' || facet.label === 'tags' || facet.label === 'ss_has_tags') {
                    return;
                }
        
                let facetOptionsHTML = '';
        
                if (facet.label === 'Category' && facet.type === 'list') {
                    const matchingValues = facet.values.filter(value => flattenedArray.includes(value.label));
                    if (matchingValues.length > 0) {
                        facetOptionsHTML = createOptionsHTML(matchingValues, facet.field);
                        createFacetElement(facet, index, facetOptionsHTML);
                    }
                } else if (facet.type === 'range' || facet.type === 'slider') {
                    const minPrice = facet.range[0];
                    const maxPrice = facet.range[1];
                    const step = getStep(minPrice, maxPrice);
                    facetOptionsHTML = `
                        <div class="price_range price_range-${facet.field}">
                            <span class="price-highest">The highest price is $${maxPrice}</span>
                            <price-slider class="price_slider_wrapper">
                                <div class="slider">
                                    <div class="progress"></div>
                                </div>
                                <div class="natori-range-input">
                                    <input type="range" class="range-min" min="${minPrice}" max="${maxPrice}" value="${minPrice}" step="${step}">
                                    <input type="range" class="range-max" min="${minPrice}" max="${maxPrice}" value="${maxPrice}" step="${step}">
                                </div>
                                <div class="price_slider_amount natori-price-input">
                                      <div class="field">
                                          <span class="field-currency">$</span>
                                          <input type="number" class="input-min" value="${minPrice}">
                                      </div>
                                      <div class="field">
                                          <span class="field-currency">$</span>
                                          <input type="number" class="input-max" value="${maxPrice}">
                                      </div>
                                </div>
                            </price-slider>
                        </div>
                    `;
                    createFacetElement(facet, index, facetOptionsHTML);
                } else if (facet.type === 'list' && facet.label !== 'Price') {
                    facetOptionsHTML = createOptionsHTML(facet.values, facet.field);
                    createFacetElement(facet, index, facetOptionsHTML);
                }
            });
        
            await attachFilterListeners();
        }
    
        
        function createOptionsHTML(values, field) {
            return `
                <ul class="list-${field.replace("variant_", "")}">
                    ${values.map((value, index) => `
                        <li>
                            <input type="checkbox" name="${field}" value="${value.label}" id="Filter-${field}-${index}">
                            <label for="Filter-${field}-${index}" class="facet-checkbox" data-key="${value.value}">
                                ${value.label}
                            </label>
                            <span class="count">(${value.count})</span>
                        </li>
                    `).join('')}
                </ul>
            `;
        }
    
    
        const attachFilterListeners = async () => {
            const filterInputs = document.querySelectorAll('.facets__wrapper input[type="checkbox"], .facets__wrapper input[type="text"], #FacetFiltersFormMobile input[type="checkbox"], #FacetFiltersFormMobile input[type="text"]');
            filterInputs.forEach(input => {
                input.addEventListener('change', (event) => {
                    event.preventDefault();
                    applyFilters();
                });
            });
        };    
    
        const sendYotpoRequest = async (prodId,prodUrl) => {
            const yotpoKey = yotpo.appKey;
            const yotpoVersion = yotpo.userSettings.version;
            const data = {
                methods: [
                    {
                        method: "bottomline",
                        params: {
                            pid: prodId,
                            link: prodUrl,
                            skip_average_score: true,
                            widget_product_id: prodId 
                        }
                    }
                ],
                app_key: yotpoKey,
                is_mobile: false,
                widget_version: yotpoVersion
            };
        
            return fetch(`https://staticw2.yotpo.com/batch/app_key/${yotpoKey}/domain_key/${prodId}/widget/bottomline`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            })
            .then(response => response.json())
            .then(data => {
                return data;
            })
            .catch(error => {
                console.error('Error:', error);
                throw error;
            });
        };
      
        const productReviews = async () => {
            const productCards = document.querySelectorAll('product-card.product-card');
            for (const productCard of productCards) {
                const productBottomLine = productCard.querySelector('.product-card-info .productInfoRight .plpRatings .yotpo.bottomLine');
                const prodUrl = productCard.querySelector('.product-featured-image-link')?.href;
                if (productBottomLine && prodUrl) {
                    const prodId = productBottomLine.getAttribute('data-product-id');
                    try {
                        const yotpoWidget = await sendYotpoRequest(prodId,prodUrl);
                        if (yotpoWidget && yotpoWidget[0] && yotpoWidget[0].result) {
                            const yotpoReviews = yotpoWidget[0].result;
                            productBottomLine.innerHTML = yotpoReviews;
                        }
                    } catch (error) {
                        console.error('Failed to load Yotpo reviews for product ID:', prodId, error);
                    }
                }
            }
            await updateReviewStars();
        };
    
    
        const fetchProductsAndFiltersInner = async (queryParams) => {
            try {
                console.log('Fetching products and filters with query params:', queryParams);
                const queryString = buildQueryString(queryParams);
                const url = `${baseUrl}?${queryString}`;
                const filterString = queryParams.filter;
        
                const response = await fetch(url);
                if (!response.ok) {
                    throw new Error('Network response was not ok ' + response.statusText);
                }
                
                const data = await response.json();

                window.FASTR_FRONTEND.searchSpringQueue.push(data);

                console.log('SearchSpring results:', data);

                // console.log('Success:', data);
                if (data.results && data.results.length > 0 && data.pagination.totalResults > 0) {
                    await createProductGrid(data.results, data.merchandising.content.inline, data.pagination);
                    collectionContainer.classList.remove('ss-hide');
                    productGridContainer.removeAttribute('style');
                    await createFilters(data.facets);
                    await createMobFilters(data.facets);
                    await updateFacetValues(data.facets);
                    await createSortingOptions(data.sorting);
                    await createMobSortingOptions(data.sorting);
                    await updateColorValue();
                    await createAppliedFilters(filterString);
                    await bindFilterListeners();
                    productReviews();
                    await priceRangeSlider();
                    await removeAllFilters();
                    await facetReset();
                } else {
                  productGridContainer.innerHTML = noResults;
                  const filtersData = document.querySelectorAll('.facets-desktop-container');
                  filtersData.forEach(function(filterditems) {
                    filterditems.style.display = 'none';
                  });
                  const filtersMobile = document.querySelectorAll('.facets-mobile-container');
                  filtersMobile.forEach(function(filtermitems) {
                    filtermitems.style.display = 'none';
                  });
                }
              
            } catch (error) {
                console.error('There was a problem with the fetch operation:', error);
                await hideSpinner();
            }
        };

        const fetchProductsAndFilters = debounce(fetchProductsAndFiltersInner, 100);
    
        const createMobSortingOptions = async (sortingData) => {
        
            const oldSort = document.querySelector('.thb-filter-sort-count.thb-filter');
            if (oldSort) {
                oldSort.remove();
            }
    
            const sortContainer = document.createElement('div');
            sortContainer.classList = "thb-filter-sort-count thb-filter";
        
            const sortFilter = document.createElement('div');
            sortFilter.classList = "thb-filter-sort";
        
            const sortTitle = document.createElement('div');
            sortTitle.classList = "thb-filter-title";
            sortTitle.textContent = "Sort by";
        
            const sortSelect = document.createElement('div');
            sortSelect.classList = "select";
        
            const sortingSelect = document.createElement('select');
            sortingSelect.id = 'SortBy';
            sortingSelect.style.minWidth = "160px";
        
            sortingData.options.forEach(option => {
                const sortOption = document.createElement('option');
                sortOption.value = `${option.field}-${option.direction}`;
                sortOption.textContent = option.label;
                if (option.active) {
                    sortOption.selected = true;
                }
                sortingSelect.appendChild(sortOption);
            });
        
            const sortLabel = document.createElement('label');
            sortLabel.setAttribute('for', 'SortByMobile');
            sortLabel.classList.add('visually-hidden');
            sortLabel.textContent = 'Sort by';
        
            sortSelect.appendChild(sortLabel);
            sortSelect.appendChild(sortingSelect);
        
            sortFilter.appendChild(sortTitle);
            sortFilter.appendChild(sortSelect);
        
            sortContainer.appendChild(sortFilter);
        
            const filterMobContainer = document.getElementById('FacetFiltersFormMobile');
            filterMobContainer.appendChild(sortContainer);
            await bindMobSortingfunction();
        };
    
    
        const createSortingOptions = async (sortingData) => {
            const sortingSelect = document.getElementById('SortBy');
            sortingSelect.style.minWidth = "160px";
            sortingSelect.innerHTML = '';
        
            sortingData.options.forEach(option => {
                const sortOption = document.createElement('option');
                sortOption.value = `${option.field}-${option.direction}`;
                sortOption.textContent = option.label;
                if (option.active) {
                    sortOption.selected = true;
                }
                sortingSelect.appendChild(sortOption);
            });
        };
    
    
        const createAppliedFilters = async (filterString) => {
            if (!filterString || typeof filterString !== 'object') return;
        
            const filterSelectElements = document.querySelectorAll('facet-remove.active-facets');
            if (!filterSelectElements.length) return;
            let storedFilters = JSON.parse(sessionStorage.getItem('natoriFilters') || '{}');
            const updatedFilters = { ...storedFilters, ...filterString };
            sessionStorage.setItem('natoriFilters', JSON.stringify(updatedFilters));
        
            filterSelectElements.forEach(filterSelect => {
                filterSelect.querySelectorAll('.active-facets__button').forEach(el => el.remove());
                Object.keys(updatedFilters).forEach(key => {
                    const filterValue = updatedFilters[key];
        
                    if (!filterValue || filterValue.length === 0 || key === "collection_handle" || key === "ss_available" || key === "tags" || key === 'ss_has_tags') return;
                    if(key == 'variant_price'){
                        const lowPrices = {};
                        const highPrices = {};
                        if (typeof filterValue === 'object' && filterValue !== null && 'low' in filterValue && 'high' in filterValue) {
                            lowPrices[key] = filterValue.low;
                            highPrices[key] = filterValue.high;
                        }
                        const currentUrl = new URL(window.location.href);
                        const filterLink = document.createElement('a');
                        filterLink.href = currentUrl.toString();
                        filterLink.classList.add('active-facets__button');
                        filterLink.innerHTML = `
                            Price range : ${lowPrices[key] || 'N/A'} - ${highPrices[key] || 'N/A'}
                            <span>
                                <svg width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6.4731 6.875C6.60027 6.875 6.72968 6.82592 6.82561 6.72775C7.01972 6.53364 7.01972 6.21682 6.82561 6.02049L4.67929 3.87416L6.82561 1.72784C7.01972 1.53373 7.01972 1.21692 6.82561 1.02058C6.63151 0.826473 6.31469 0.826473 6.11835 1.02058L3.97203 3.1669L1.82794 1.02504C1.63383 0.830936 1.31701 0.830936 1.12068 1.02504C0.926571 1.21915 0.926571 1.53596 1.12068 1.7323L3.267 3.87863L1.12291 6.02049C0.928802 6.21459 0.928802 6.53141 1.12291 6.72775C1.22108 6.82592 1.34825 6.875 1.47542 6.875C1.6026 6.875 1.732 6.82592 1.82794 6.72775L3.97426 4.58142L6.12058 6.72775C6.21652 6.82592 6.34593 6.875 6.4731 6.875Z" fill="var(--color-accent)"></path>
                                </svg>
                            </span>
                        `;
    
                        const removeButton = filterSelect.querySelector('a.active-facets__button-remove');
                        if (removeButton) {
                            filterSelect.insertBefore(filterLink, removeButton);
                        } else {
                            filterSelect.appendChild(filterLink);
                        }
                    } else {
                        if (Array.isArray(filterValue)) {
                            filterValue.forEach(value => {
                                appendFilterElement(key, value, filterSelect, updatedFilters);
                            });
                        } else {
                            appendFilterElement(key, filterValue, filterSelect, updatedFilters);
                        }
                    }
                });
            });
        };
    
        const appendFilterElement = async(key, value, filterSelect, updatedFilters) => {
            const filterLink = document.createElement('a');
            filterLink.href = generateFilterUrl(key, updatedFilters);
            filterLink.classList.add('active-facets__button');
            
            if (key === 'variant_color') {
                filterLink.classList.add('active-facets__button--color');
                const colorKey = value.trim();
                
                if (colorKey) {
                    const styleValue = await fetchColorValue(colorKey);
                    const styles = styleValue.split(';').filter(Boolean);
    
                    styles.forEach(style => {
                        const [property, value] = style.split(':').map(s => s.trim());
                        if (property && value) {
                            filterLink.style.setProperty(property, value);
                        }
                    });
                } else {
                    filterLink.style.setProperty('--bg-color', `var(--bg-body)`);
                    filterLink.style.setProperty('--option-color-image', 'url(false)');
                }
            }
    
        
            filterLink.innerHTML = `
                ${value}
                <span>
                  <svg width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.4731 6.875C6.60027 6.875 6.72968 6.82592 6.82561 6.72775C7.01972 6.53364 7.01972 6.21682 6.82561 6.02049L4.67929 3.87416L6.82561 1.72784C7.01972 1.53373 7.01972 1.21692 6.82561 1.02058C6.63151 0.826473 6.31469 0.826473 6.11835 1.02058L3.97203 3.1669L1.82794 1.02504C1.63383 0.830936 1.31701 0.830936 1.12068 1.02504C0.926571 1.21915 0.926571 1.53596 1.12068 1.7323L3.267 3.87863L1.12291 6.02049C0.928802 6.21459 0.928802 6.53141 1.12291 6.72775C1.22108 6.82592 1.34825 6.875 1.47542 6.875C1.6026 6.875 1.732 6.82592 1.82794 6.72775L3.97426 4.58142L6.12058 6.72775C6.21652 6.82592 6.34593 6.875 6.4731 6.875Z" fill="var(--color-accent)"></path>
                  </svg>
                </span>
            `;
        
            const removeButton = filterSelect.querySelector('a.active-facets__button-remove');
            filterSelect.insertBefore(filterLink, removeButton);
        };
        
        const generateFilterUrl = async (currentKey, updatedFilters) => {
            const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.delete(currentKey);
            Object.keys(updatedFilters).forEach(key => {
                if (updatedFilters[key]) {
                  if(key !== "collection_handle" && key !== "ss_available" && key !== "tags" && key !== "ss_has_tags" ){
                    if (Array.isArray(updatedFilters[key])) {
                        updatedFilters[key].forEach(value => {
                            currentUrl.searchParams.append(key, value);
                        });
                    } else {
                        currentUrl.searchParams.set(key, updatedFilters[key]);
                    }
                  }
                }
            });
            return currentUrl.toString();
        };
    
        const  handleProductCardHover = async () => {
            const productCards = document.querySelectorAll('product-card.product-card');
        
            productCards.forEach((productCard) => {
                const swatches = productCard.querySelector('.product-card-swatches');
                const image = productCard.querySelector('.product-featured-image-link .product-primary-image');
                const href = productCard.querySelector('.product-featured-image-link');
                const secondary = productCard.querySelector('.product-featured-image-link .product-secondary-image');
                const swatchList = swatches ? swatches.querySelectorAll('.product-card-swatch') : [];
        
                swatchList.forEach((swatch) => {  
                    swatch.addEventListener('mouseover', () => {   
                      swatchList.forEach((el) => {
                          el.classList.remove('active');
                      });
                      swatch.classList.add('active');
                      const primaryDataset = swatch.getAttribute('data-srcset');
                      const secondaryDataset = swatch.getAttribute('data-srcset-2');
                      const urlDataset = swatch.getAttribute('data-href');
                        if(urlDataset){
                          href.setAttribute('href', urlDataset);
                        }
                        if (image) {   
                            if (primaryDataset) {
                                image.setAttribute('srcset', primaryDataset);
                            }
                            if (secondary) {
                                if (secondaryDataset) {
                                    secondary.setAttribute('srcset', secondaryDataset);
                                }
                            }
                        }
                    });
                });
            });
        };
    
        const updateFeatureImages = async () => {
            const featuredImages = document.querySelectorAll('figure.product-featured-image');
            featuredImages.forEach((figure) => {
                const secondaryImage = figure.querySelector('img.product-secondary-image');
                if (!secondaryImage) {
                    figure.classList.remove('thb-hover');
                } else {
                    figure.classList.add('thb-hover');
                }
            });
        };
    
        const applyFilters = async () => {
            document.querySelectorAll('.facets__form details.thb-filter').forEach((detailElement) => {
                detailElement.removeAttribute('open');
            });
            const filterSidebar = document.querySelector('facetfiltersformmobile .facet-drawer.side-panel');
            if (filterSidebar) {
                filterSidebar.classList.remove('active');
            }
            const body = document.querySelector('body');
            if (body) {
                body.classList.remove('open-cc');
            }
            const filterInputs = document.querySelectorAll('.facets__wrapper input[type="checkbox"]:checked, .facets__wrapper input[type="text"], #FacetFiltersFormMobile input[type="checkbox"]:checked, #FacetFiltersFormMobile input[type="text"]');
            const filterParams = { ...queryParams.filter };
            filterInputs.forEach(input => {
                const name = input.name;
                const value = input.value;
            
                if (!filterParams[name]) {
                    filterParams[name] = input.type === 'checkbox' ? [] : '';
                }
            
                if (input.type === 'checkbox') {
                    if (Array.isArray(filterParams[name])) {
                        if (!filterParams[name].includes(value)) {
                            filterParams[name].push(value);
                        }
                    } else {
                        filterParams[name] = [value];
                    }
                } else if (input.type === 'text') {
                    filterParams[name] = value;
                }
            });
            
            queryParams.filter = filterParams;
            queryParams.page = 1;
        
            // Update session storage with the new filters
            sessionStorage.setItem('natoriFilters', JSON.stringify(filterParams));
        
            fetchProductsAndFilters(queryParams);
        };
        
    
        const remClass = async () => {
            const filterSidebar = document.querySelector('facetfiltersformmobile .facet-drawer.side-panel');
            if (filterSidebar) {
                filterSidebar.classList.remove('active');
            }
            const body = document.querySelector('body');
            if (body) {
                body.classList.remove('open-cc');
            }
            const remLoadingGird = document.getElementById('product-grid');
            if(remLoadingGird){
                remLoadingGird.classList.remove('loading');
            }
            const removeLoading = document.querySelectorAll('span.thb-filter-count.mobile-filter-count.body-font, .facets-mobile-container .thb-filter-count');
            removeLoading.forEach(remEle => {
                remEle.classList.remove('loading');
            });
        };        
    
    
        document.getElementById('SortBy').addEventListener('change', async function(event) {
            const [field, direction] = event.target.value.split('-');
            queryParams.sort = { [field]: direction };
            const updatedSortString = { [field]: direction };
            sessionStorage.setItem('natoriSortData', JSON.stringify(updatedSortString));
            queryParams.page = 1;
            fetchProductsAndFilters(queryParams);
        });
        
        async function updateQueryParams(queryParams) {
            let storedFilters = JSON.parse(sessionStorage.getItem('natoriFilters') || '{}');
            let storedSort = JSON.parse(sessionStorage.getItem('natoriSortData') || '{}');
        
            if (Object.keys(storedFilters).length > 0) {
                queryParams.filter = {
                    ...queryParams.filter,
                    ...storedFilters
                };
            }
        
            if (Object.keys(storedSort).length > 0) {
                queryParams.sort = storedSort;
            }
        
            return queryParams;
        }        
    
        const bindMobSortingfunction = async () => {
            const sortByElement = document.querySelector('#FacetFiltersFormMobile .thb-filter-sort #SortBy');
            if (sortByElement) {
                sortByElement.addEventListener('change', function(event) {
                    const filterSidebar = document.querySelector('facetfiltersformmobile .facet-drawer.side-panel');
                    if (filterSidebar) {
                        filterSidebar.classList.remove('active');
                    }
                    const body = document.querySelector('body');
                    if (body) {
                        body.classList.remove('open-cc');
                    }
                    const [field, direction] = event.target.value.split('-');
                    queryParams.sort = { [field]: direction };
                    const updatedSortString = { [field]: direction };
                    sessionStorage.setItem('natoriSortData', JSON.stringify(updatedSortString));
                    queryParams.page = 1;
                    fetchProductsAndFilters(queryParams);
                });
            } else {
                console.error('Sorting element not found. Unable to bind event listener.');
            }
        };
        
    
    
        const bindFilterListeners = async () => {
            const removeFilterButtons = document.querySelectorAll('facet-remove.active-facets .active-facets__button');
            removeFilterButtons.forEach(remBtn => {
                remBtn.addEventListener('click', async (event) => {
                    event.preventDefault();
        
                    const valueText = Array.from(remBtn.childNodes).filter(node => node.nodeType === Node.TEXT_NODE).map(textNode => textNode.textContent.trim()).join(' ');
                    const normalizedValueText = valueText.trim();  
        
                    const updatedFilterString = Object.entries(queryParams.filter).reduce((acc, [key, values]) => {
                        if (Array.isArray(values)) {
                            const filteredValues = values.map(value => value.trim()).filter(value => value !== normalizedValueText);
                            if (filteredValues.length > 0) {
                                acc[key] = filteredValues;
                            }
                        } else {
                            acc[key] = values;
                        }
                        return acc;
                    }, {});
        
                    if (normalizedValueText.includes('Price range :')) {
                        delete updatedFilterString['variant_price'];
                    }
        
                    queryParams.filter = updatedFilterString;
        
                    // Update session storage with the new filters
                    sessionStorage.setItem('natoriFilters', JSON.stringify(updatedFilterString));
                    fetchProductsAndFilters(queryParams);
                });
            });
        };
        
    
        const removeAllFilters = async () => {
            const removeAllFilterButtons = document.querySelectorAll('.active-facets__button-remove');
        
            if (removeAllFilterButtons.length > 0) {
                removeAllFilterButtons.forEach(button => {
                    button.addEventListener('click', async (event) => {
                        event.preventDefault();
        
                        const updatedFilterString = {};
                        queryParams.filter = updatedFilterString;
                        pageLoad = true;
        
                        // Clear filters from session storage
                        sessionStorage.setItem('natoriFilters', JSON.stringify(updatedFilterString));
        
                        await fetchProductsAndFilters(queryParams);
                    });
                });
            } else {
                console.warn('Remove all filter buttons not found.');
            }
        };
        
    
        const updateReviewStars = async () => {
            const productInfoRights = document.querySelectorAll('.collection-page #ProductGridContainer #product-grid li.column .productInfosection .productInfoRight');
        
            productInfoRights.forEach(productInfoRight => {
                const plpRatings = productInfoRight.querySelector('.plpRatings');
                if (plpRatings) {
                    const yotpoStar = plpRatings.querySelector('.yotpo .yotpo-bottomline .yotpo-icon-star');
                    if (!yotpoStar) {
                        plpRatings.remove();
                    }
                }
            });
        };
    
          
        const initializeCustomSwatches = async () => {
            if (abortController) {
                abortController.abort();
            }
            abortController = new AbortController();
        
            const fetchProductDetails = async (multipleIds) => {
                const storefrontAccessToken = '4ab0ea4a4961a53e2dcd92763fbb7674';
                const url = `https://${shopUrl}/api/2024-10/graphql.json`;
            
                const productQuery = `
                    query Products($ids: [ID!]!, $country: CountryCode) @inContext(country: $country) {
                        nodes(ids: $ids) {
                            ... on Product {
                                id
                                title
                                handle
                                discontinued: metafield(namespace: "custom", key: "discontinued") {
                                    value
                                    type
                                }
                                totalInventory
                                priceRange {
                                    maxVariantPrice {
                                        amount
                                        currencyCode
                                    }
                                    minVariantPrice {
                                        amount
                                        currencyCode
                                    }
                                }
                                variantSwatchColor: metafield(namespace: "custom" key: "variant_swatch_color") {
                                    value
                                    type
                                }
                                images(first: 2) {
                                    edges {
                                        node {
                                            src
                                            altText
                                        }
                                    }
                                }
                                variants(first: 100) {
                                    edges {
                                        node {
                                            id
                                            title
                                            quantityAvailable
                                            compareAtPrice {
                                                amount
                                                currencyCode
                                            }
                                            selectedOptions {
                                                name
                                                value
                                            }
                                            image {
                                                src
                                                altText
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                `;
              
                try {
                    const response = await fetch(url, {
                        method: "POST",
                        headers: {
                            'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            query: productQuery,
                            variables: {
                                ids: multipleIds,
                                country: Shopify.country
                            }
                        }),
                        signal: abortController.signal
                    });
            
                    const { data, errors } = await response.json();
            
                    if (errors) {
                        console.error('GraphQL Errors:', errors);
                        return null;
                    }

                    if (data && data.nodes) {
                        const productDetails = data.nodes.map(product => {
                            if (product) {
                                const isAvailable = product.totalInventory > 0;
                        
                                return {
                                    ...product,
                                    available: isAvailable
                                };
                            } else {
                                console.warn("Encountered a null product.");
                                return null;
                            }
                        }).filter(Boolean);
            
                        return productDetails;
                    } else {
                        console.warn("No product data found.");
                        return null;
                    }
                } catch (error) {
                    if (error.name === 'AbortError') {
                        console.warn("Request aborted without a reason.");
                        return null;
                    } else {
                        console.error("Error fetching product:", error);
                        throw error;
                    }
                }
            };

        
            const processProductDetails = async ( product, keyArray, valArray, featuredImageId, productDataElements, productId, primaryImagesrc, secondaryImagesrc, mainHandle, uniqueColors, counter, productAvailable ) => {
                if (product && product.variants && product.variants.edges) {
                    let storedVariants = JSON.parse(sessionStorage.getItem('natoriCustomVariants') || '{}');
                    let customVarList = storedVariants[productId]?.variants || [];
                    for (const edge of product.variants.edges) {
                        const variant = edge.node;
                        const productQuan = productAvailable;
                        if (variant) {
                            let variantCustomId = parseInt(variant.id.split("/").pop());
                            if (!customVarList.includes(variantCustomId)) {
                                for (const option of variant.selectedOptions) {
                                    if (option.name.toLowerCase() === "color" || option.name.toLowerCase() === "colour" || option.name.toLowerCase() === "couleur") {
                                        const key = option.value;
                                        if (!uniqueColors.has(key) && counter.count < 6) {
                                            uniqueColors.set(key, option);
                                            if (option.value.length > 0) {
                                                let swatchHtml = "";
                                                let active = "";
                                                let variantImage = "";
                                                let variantUrl = "";
                                                let srcset = "";
                                                let variantId = parseInt(variant.id.split("/").pop());
        
                                                if (variant) {
                                                    if (variantId === featuredImageId) {
                                                        active = "active";
                                                    }
                                                    if (primaryImagesrc) {
                                                        variantImage = primaryImagesrc;
                                                    }
                                                    // variantUrl = `/products/${product.handle}?variant=${variantId}`;
                                                    variantUrl = `/products/${product.handle}`;
                                                }
                                                const imageSizes = "{{ sizes }}".split(",");
        
                                                if (variantImage) {
                                                    imageSizes.forEach((size) => {
                                                        const sizeArray = size.split("x");
                                                        const sizeX = sizeArray[0] + "x" + (sizeArray[1] !== "0" ? sizeArray[1] : "");
                                                        srcset += `${variantImage.replace(".jpg", `_${sizeX}.jpg`)} ${sizeArray[0]}w, `;
                                                    });
                                                }
                                                let colorValue = key.toLowerCase().trim();
                                                const customColorIndex = keyArray.indexOf(colorValue);
                                                if (customColorIndex > -1) {
                                                    colorValue = valArray[customColorIndex];
                                                }
                                                let bgValue = false;
                                                const swatchColor = product.variantSwatchColor?.value;
                                                if (swatchColor) {
                                                    const swatchParts = swatchColor.split('-');
                                                    const lastPart = swatchParts[swatchParts.length - 1].trim();
                                                    if (lastPart.includes('#')) {
                                                        colorValue = lastPart;
                                                    } else {
                                                        bgValue = lastPart;
                                                        colorValue = "var(--bg-body)";
                                                    }
                                                } else {
                                                    if (colorValue.includes(".")) {
                                                        bgValue = colorValue;
                                                        colorValue = "var(--bg-body)";
                                                    }
                                                }
                                                const shopDomain = window.location.hostname;
                                                const bgImageUrl = bgValue ? `--option-color-image: url('//${shopDomain}/cdn/shop/files/${bgValue}');` : "";
                                                swatchHtml += `
                                                    <div class="product-card-swatch ${active}"
                                                        style="--option-color: ${colorValue}; ${bgImageUrl}" 
                                                        data-srcset-2="${secondaryImagesrc}" 
                                                        data-srcset="${variantImage}"
                                                        data-href="${variantUrl}"
                                                        data-quan="${productQuan}">
                                                        <span class="visually-hidden">${key}</span>
                                                    </div>
                                                `;
                                                if (productDataElements) {
                                                    const existingSwatches = productDataElements.querySelectorAll('.product-card-swatch');
                                                    const isSwatchExists = existingSwatches.length > 0 && productDataElements.querySelector(`.product-card-swatch[data-href="${variantUrl}"]`);
                                                    if (!isSwatchExists && existingSwatches.length < 6) {
                                                        productDataElements.insertAdjacentHTML("beforeend", swatchHtml);
                                                        counter.count++;
                                                    }
                                                }

                                            }
                                        }
                                    }
                                }
                                if (counter.count >= 6) break;
                                customVarList.push(variantCustomId);
                            }
                        }
                    }
        
                    storedVariants[productId] = { variants: customVarList };
                    sessionStorage.setItem('natoriCustomVariants', JSON.stringify(storedVariants));
        
                    if (uniqueColors.size > 5 && counter.count >= 5) {
                        const moreButtonHtml = `<div class="morebtn"><a href="${mainHandle}" intellisuggest="" ss-ps="">+ More</a></div>`;
                        productDataElements.insertAdjacentHTML("beforeend", moreButtonHtml);
                    }
                }
            };
        
            const handleCustomSwatches = async () => {
                sessionStorage.removeItem('natoriCustomVariants');
                const productCards = document.querySelectorAll(".product-card-swatch");
                productCards.forEach(card => {
                    const prodOldSwatches = card.querySelector('.product-card-swatches');
                    if (prodOldSwatches) {
                        prodOldSwatches.innerHTML = '';
                    }
                });
                const productIds = Array.from(productCards).map(
                    (card) => card.dataset.productId
                );
                for (const productId of productIds) {
                    const settings = window[`settings_${productId}`];
                    const color_settings = window[`settings`];
        
                    const customColorsArray = color_settings.color_swatches.split(',').map(color => {
                        const [key, value] = color.split(':').map(part => part.trim());
                        return { key: key.toLowerCase(), value: value };
                    });
        
                    const keyArray = customColorsArray.map((color) => color.key);
                    const valArray = customColorsArray.map((color) => color.value);
                    const multipleIds = settings.product_gids;
                    const productDetails = await fetchProductDetails(multipleIds);
                    let uniqueColors = new Map();
                    let counter = { count: 0 };

                    const secondaryImageSrc = productDetails .filter(pd => pd.id === `gid://shopify/Product/${productId}`) .flatMap(pd => pd.images.edges) .map(edge => edge.node.src)[1];
                    const prodCard = document.querySelector(`product-card.product-card:has(.product-card-swatch[data-product-id='${productId}'])`);
                    if(secondaryImageSrc){
                        const prodImage = prodCard.querySelector('figure.product-featured-image img.product-primary-image');
                        const featuredImage = prodCard.querySelector('figure.product-featured-image');
                        const prodImageContainer = prodCard.querySelector('figure.product-featured-image .product-featured-image-link');
                        const prodSecondaryImage = document.createElement('img');
                        prodSecondaryImage.src = secondaryImageSrc;
                        prodSecondaryImage.alt = prodImage.alt;
                        prodSecondaryImage.style.width = '100%';
                        prodSecondaryImage.style.height = '100%';
                        prodSecondaryImage.classList.add('product-secondary-image');
                        prodImageContainer.insertBefore(prodSecondaryImage, prodImage);
                        featuredImage.classList.add('thb-hover');
                    }


                    const minPrice = Math.min(...productDetails.filter(pd => pd.totalInventory > 0).map(pd => pd.priceRange.minVariantPrice.amount));
                    const maxPrice = Math.max(...productDetails.filter(pd => pd.totalInventory > 0).map(pd => pd.priceRange.maxVariantPrice.amount));
                    const compareAtPrices = productDetails .filter(pd => pd.totalInventory > 0) .flatMap(pd => pd.variants.edges.map(edge => edge.node?.compareAtPrice?.amount).filter(amount => amount != null));
                    const CompareAtPrice = compareAtPrices.length > 0 ? Math.min(...compareAtPrices) : '';
                    
                    const prodPrices = prodCard.querySelector('.product-card-info .productInfoRight span.price');
                    let priceContainer = '';
                    let comparePriceContainer = '';
                    
                    if (minPrice !== maxPrice) {
                        priceContainer = `<ins><span class="amount">${moneyFormat}${formatPrice(minPrice)} - ${moneyFormat}${formatPrice(maxPrice)}</span></ins>`;
                    } else {
                         priceContainer = `<ins><span class="amount">${moneyFormat}${formatPrice(maxPrice)}</span></ins>`;
                    }
                    
                    if (CompareAtPrice > minPrice) {
                        comparePriceContainer = `<del><span class="amount">${moneyFormat}${formatPrice(CompareAtPrice)}</span></del>`;
                    }
                    
                    prodPrices.innerHTML = comparePriceContainer + priceContainer;
                    prodCard.classList.remove('hide-price');
        
                    for (const productDetail of productDetails) {
                        if (abortController.signal.aborted) {
                            return;
                        }
                        let productAvailable;
                        if (productDetail && productDetail.available !== undefined) {
                            productAvailable = productDetail.available;
                        }
                        let discontinued;
                        if (productDetail && productDetail.discontinued !== undefined) {
                            discontinued = productDetail.discontinued?.value === "true";
                        }
                        if (productDetail && !discontinued && productAvailable) {
                            let primaryImagesrc = "";
                            let secondaryImagesrc = "";
                            if (productDetail && productDetail.images && productDetail.images.edges) {
                                const images = productDetail.images.edges.map((edge) => edge.node);
                                images.forEach((image, index) => {
                                    if (index === 0) {
                                        primaryImagesrc = image.src;
                                    }
                                    if (index === 1) {
                                        secondaryImagesrc = image.src;
                                    }
                                });
                            }
                            await processProductDetails(
                                productDetail,
                                keyArray,
                                valArray,
                                settings.featured_image_id,
                                document.getElementById("swatch_section_" + productId),
                                productId,
                                primaryImagesrc,
                                secondaryImagesrc,
                                settings.custom_handle,
                                uniqueColors,
                                counter,
                                productAvailable
                            );
                            if (counter.count >= 6) break;
                        }
                    }
                    var swatchSection = document.getElementById("swatch_section_" + productId);
                    if (swatchSection) {
                        swatchSection.parentNode.parentNode.parentNode.enableSwatches();
                    }
                }
                await handleProductCardHover();
                await collectionSwatchImages();
            };
        
            setTimeout(async () => {
                try {
                    await handleCustomSwatches();
                } catch (error) {
                    if (error.name === 'AbortError') {
                        console.warn('Handle custom swatches was aborted');
                    } else {
                        console.error('Error handling custom swatches:', error);
                    }
                }
            }, 500);
        };
    
        const hideSpinner = async() => {
            const spinners = document.querySelectorAll('figure.product-featured-image');
            spinners.forEach(spinner => {
                setTimeout(() => {
                    spinner.classList.remove('spin_overlay');
                }, 500);
            });
        };
    
        const facetReset = async () => {
            const resetButtons = document.querySelectorAll('.facets .thb-filter-dropdown__footer .facets__reset');
            const filterParams = { ...queryParams.filter };
            resetButtons.forEach(button => {
                button.addEventListener('click', (event)=>{
                    event.preventDefault();
                    const facet = button.parentNode.parentNode.parentNode;
                    facet.removeAttribute('open');
                    let facetType = facet.dataset.type;
                    if( facetType != 'ss_color_group' && facetType != 'collection_name' ){
                      facetType = `variant_${facetType}`;  
                    }
                    const checkboxes = facet.querySelectorAll('.thb-filter-dropdown__inner input[type=checkbox]');
                    checkboxes.forEach(checkbox => {
                        checkbox.checked = false;
                    });
                    const facetCounter = facet.querySelector(".thb-filter-dropdown__footer span.facets__selected");
                    if (facetCounter) {
                        facetCounter.textContent = `0 selected`;
                    }
                    delete filterParams[facetType];
                    sessionStorage.setItem('natoriFilters', JSON.stringify(filterParams));
                    queryParams.filter = filterParams;
                    queryParams.page = 1;
                    fetchProductsAndFilters(queryParams);
                });
            });
        };
    
        const priceRangeSlider = async () => {
            const rangeFilterContainers = document.querySelectorAll('.thb-filter:has(.price_range)');

            function calculateDynamicPriceGap(minRange, maxRange) {
                const totalRange = maxRange - minRange;
                let dynamicGap = Math.max(5, Math.min(100, totalRange * 0.1)); 
                return Math.round(dynamicGap / 5) * 5;
            }
            
            rangeFilterContainers.forEach((container) => {
                const rangeInputs = container.querySelectorAll(".price_range .natori-range-input input"),
                    priceInputs = container.querySelectorAll(".price_range .natori-price-input input"),
                    range = container.querySelector(".price_range .slider .progress");
    
                function updateSliderProgress() {
                    let minPrice = parseInt(priceInputs[0].value);
                    let maxPrice = parseInt(priceInputs[1].value);
                    let minRange = parseInt(rangeInputs[0].min);
                    let maxRange = parseInt(rangeInputs[0].max);
                    let priceGap = calculateDynamicPriceGap(minRange, maxRange);
        
                    if (maxPrice - minPrice >= priceGap && maxPrice <= maxRange) {
                        const effectiveRange = maxRange - minRange;
                        range.style.left = ((minPrice - minRange) / effectiveRange) * 100 + "%";
                        range.style.right = 100 - ((maxPrice - minRange) / effectiveRange) * 100 + "%";
                    }
                }
        
                updateSliderProgress();
        
                const debouncedUpdateFilter = debounce(() => applyRangeFilter(container), 1500);
        
                priceInputs.forEach((input) => {
                    input.addEventListener("input", (e) => {
                        let minPrice = parseInt(priceInputs[0].value),
                            maxPrice = parseInt(priceInputs[1].value);
                        let minRange = parseInt(rangeInputs[0].min);
                        let maxRange = parseInt(rangeInputs[0].max);
                        let priceGap = calculateDynamicPriceGap(minRange, maxRange);
            
                        if (maxPrice - minPrice >= priceGap && maxPrice <= maxRange) {
                            if (e.target.classList.contains("input-min")) {
                                rangeInputs[0].value = minPrice;
                            } else {
                                rangeInputs[1].value = maxPrice;
                            }
                            const effectiveRange = maxRange - minRange;
                            range.style.left = ((minPrice - minRange) / effectiveRange) * 100 + "%";
                            range.style.right = 100 - ((maxPrice - minRange) / effectiveRange) * 100 + "%";
                        }
                        debouncedUpdateFilter();
                    });
                });
        
                rangeInputs.forEach((input) => {
                    input.addEventListener("input", (e) => {
                        let minVal = parseInt(rangeInputs[0].value),
                            maxVal = parseInt(rangeInputs[1].value);
                        let minRange = parseInt(rangeInputs[0].min);
                        let maxRange = parseInt(rangeInputs[0].max);
                        let priceGap = calculateDynamicPriceGap(minRange, maxRange);
        
                        if (maxVal - minVal < priceGap) {
                            if (e.target.classList.contains("range-min")) {
                                rangeInputs[0].value = maxVal - priceGap;
                            } else {
                                rangeInputs[1].value = minVal + priceGap;
                            }
                        } else {
                            priceInputs[0].value = minVal;
                            priceInputs[1].value = maxVal;
                            const effectiveRange = maxRange - minRange;
                            range.style.left = ((minVal - minRange) / effectiveRange) * 100 + "%";
                            range.style.right = 100 - ((maxVal - minRange) / effectiveRange) * 100 + "%";
                        }
                        debouncedUpdateFilter();
                    });
                });
            });
        };
        
        const applyRangeFilter = async (container) => {
            document.querySelectorAll('.facets__form details.thb-filter').forEach((detailElement) => {
                detailElement.removeAttribute('open');
            });
            const filterSidebar = document.querySelector('facetfiltersformmobile .facet-drawer.side-panel');
            if (filterSidebar) {
                filterSidebar.classList.remove('active');
            }
            const body = document.querySelector('body');
            if (body) {
                body.classList.remove('open-cc');
            }
            const priceMin = container.querySelector('.range-min').value;
            const priceMax = container.querySelector('.range-max').value;
    
            const variantPrice = {
                low: priceMin, 
                high: priceMax
            };
        
            const variantPriceKey = 'variant_price';
            const filterParams = { ...queryParams.filter };
            filterParams[variantPriceKey] = variantPrice;
            let storedFilters = JSON.parse(sessionStorage.getItem('natoriFilters') || '{}');
            const updatedFilters = { ...storedFilters, ...filterParams };
            sessionStorage.setItem('natoriFilters', JSON.stringify(updatedFilters));
            queryParams.filter = filterParams;
            queryParams.page = 1;
        
            fetchProductsAndFilters(queryParams);
        };
    
        const flattenCategories = async (categories) => {
            let result = [];
        
            for (const category of categories) {
                if (category.filter === "true") {
                    result.push(category.title);
                }
        
                if (category.children) {
                    const childTitles = await flattenCategories(category.children);
                    result = result.concat(childTitles);
                }
            }
            return result;
        };

        await checkAndValidateFilters(collectionHandle);
        await updateQueryParams(queryParams);
        await removeAllFilters();
        await FacetsToggle();
        fetchProductsAndFilters(queryParams);
    }
});
